import { render, staticRenderFns } from "./OutcomeAppointment.vue?vue&type=template&id=56ceb87f"
import script from "./OutcomeAppointment.vue?vue&type=script&lang=js"
export * from "./OutcomeAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports